import {
  ChildTypeGroupingRule,
  PerspectivesGroupsComponentTypes,
  PerspectivesGroupsWorkspace,
  toComponentTypeOption,
  toWorkspaceOption,
} from '@ardoq/perspectives';
import { Select } from '@ardoq/select';
import { type I18nLocale, t } from '@ardoq/i18n';
import { ArdoqId } from '@ardoq/api-types';
import { RowHeader } from '../../atoms';

type ChildTypeGroupRuleProps = {
  groupingRule: ChildTypeGroupingRule;
  workspaces: PerspectivesGroupsWorkspace[];
  componentTypesPerWorkspace: Record<
    ArdoqId,
    PerspectivesGroupsComponentTypes[]
  >;
  i18nLocale?: I18nLocale;
};

/**
 * @deprecated
 * This grouping rule has been deprecated and user can only use it if it is a part of Saved perspective.
 * Creating a new Child grouping rule is no longer possible.
 * This rule is read-only and cannot be updated.
 */
const ChildGroupRule = ({
  workspaces,
  groupingRule,
  componentTypesPerWorkspace,
  i18nLocale = {},
}: ChildTypeGroupRuleProps) => {
  const workspaceOptions = workspaces.map(workspace =>
    toWorkspaceOption(workspace)
  );
  const componentTypes =
    componentTypesPerWorkspace[groupingRule.workspaceId!] ?? [];
  const componentTypeOptions = componentTypes.map(toComponentTypeOption);

  return (
    <>
      <RowHeader>
        {t(
          i18nLocale,
          'perspectivesSidebar:groupingRules.inWorkspace',
          'In workspace'
        )}
      </RowHeader>
      <Select
        dataTestId="child-grouping-rule-workspace-select"
        value={groupingRule.workspaceId}
        options={workspaceOptions}
        aria-label={t(
          i18nLocale,
          'perspectivesSidebar:groupingRules.workspaceAriaLabel',
          'Workspace'
        )}
        isDisabled
        menuPortalTarget={null}
      />
      <RowHeader>
        {t(i18nLocale, 'perspectivesSidebar:groupingRules.type', 'Type')}
      </RowHeader>
      <Select
        aria-label={t(
          i18nLocale,
          'perspectivesSidebar:groupingRules.componentTypesAriaLabel',
          'Component types'
        )}
        dataTestId="child-grouping-rule-component-type-select"
        options={componentTypeOptions}
        value={groupingRule.targetId}
        isDisabled
        menuPortalTarget={null}
      />
    </>
  );
};

export { ChildGroupRule };
